export const css = {
    root: '_1b0mbtxu',
    assess_card: '_1sO0fgHW',
    loading_card: '_3TwEpiEA',
    title: '_1bitg4jE',
    actions: 'JSSVJ7h5',
    ' _key': 'explore-view/nav-card'
};
export default css;
